// ============================================================================
// SYSTELOS - AppLayout Component
// ============================================================================
// Wrapper principal que combina Header + Sidebar + Content
// Gerencia estado do sidebar e eventos de teclado
// ============================================================================

import { useState, useEffect } from 'react'
import { Header } from './Header'
import { Sidebar } from './Sidebar'

interface AppLayoutProps {
  children: React.ReactNode
  pagina?: string
}

export function AppLayout({ children, pagina = 'Dashboard' }: AppLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  // Fechar sidebar com ESC
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setSidebarOpen(false)
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [])

  // Prevenir scroll quando sidebar está aberto
  useEffect(() => {
    if (sidebarOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [sidebarOpen])

  return (
    <div 
      className="min-h-screen"
      style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8ed 100%)' }}
    >
      {/* Header */}
      <Header onMenuClick={() => setSidebarOpen(true)} pagina={pagina} />

      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Conteúdo Principal */}
      {/* pt-[73px] = 70px header + 3px borda */}
      <main className="pt-[73px] min-h-screen">
        {children}
      </main>
    </div>
  )
}

export default AppLayout

